import { Config } from '../config/config.es6';
import Utils from '../utils/main.es6';

export default class Top {
    constructor() {
        this.tapCount = 0;
        this.isClear = false;
        this.query = Utils.getQuery() || {};
    }

    async sendAPI(sceneId) {
        try {
            const res = await ATRI_KANINOME_API.register(sceneId);
            if (res.status) console.log('resigst: ', sceneId);
            else throw new Error(res.reason);
        } catch (e) {
            console.log(e.message);
        }
    }

    async getAPI() {
        this.tapCount = await ATRI_KANINOME_API.fetchCount();
        if (this.query.count) this.tapCount = parseInt(this.query.count);
        return this.tapCount;
    }

    get() {
        return this.tapCount;
    }

    getAchevementCount(tapCount) {
        let achevementCount = 0;

        if (tapCount >= Config.ACHIVEMENT_COUNT[1]) {
            achevementCount = 2;
        } else if (tapCount >= Config.ACHIVEMENT_COUNT[0]) {
            achevementCount = 1;
        }

        return achevementCount;
    }

    getMainCount(tapCount, achevementCount) {
        let mainCount = 0;

        if (achevementCount === 0) {
            mainCount = Config.ACHIVEMENT_COUNT[0] - tapCount;
        } else if (achevementCount === 1) {
            mainCount = Config.ACHIVEMENT_COUNT[1] - tapCount;
        }

        return mainCount;
    }

    isActiveReward(targetReward, achevementCount) {
        return Number(targetReward) <= achevementCount;
    }

    getRewardPath(rewardNum) {
        return `/special/kaninome/assets/img/rewardmodal/${Config.REWARD_DIR[rewardNum]}/ph.jpg`;
    }
}
